module.exports = __webpack_public_path__ + "19361d0468aec75456e5c7818fddf446.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/poster-mockup.jpg
// module id = 800
// module chunks = 0